module.exports = __webpack_public_path__ + "static/media/hazel.2bfe61b7.jpg";